import { useContext } from 'react';

import { NewClientsListContext } from '@pages/Clients/NewClientsList/context/NewClientsListContext';

export const useNewClientsListContext = () => {
  const context = useContext(NewClientsListContext);

  if (!context) {
    throw new Error(
      'useNewClientsListContext must be used within a NewClientsListProvider'
    );
  }

  return context;
};
